import React from 'react'
import { InputLabel, InputItemWrap, DHA, AuthButton, FormContainer, LoginHeader, FormMain, LoginFooter, FormMainHeader, InputFieldItem } from 'pages/auth/auth.styled'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom' 
import { register, registerChurch } from '../../features/auth/authSlice'
import { verifyRegisterData, resetAuth, setViewEmailConfirmModal, sendVerificationEmailCode } from '../../features/auth/authSlice'  
import ReCAPTCHA from 'react-google-recaptcha'
import {useState, useEffect, useRef} from 'react' 
import SelectUserType from './SelectUserType'
import { toast } from 'react-toastify'
import { IoAtSharp } from "react-icons/io5";
import SpinnerSmall from 'components/SpinnerSmall'
import { useTranslation } from 'react-i18next'

const countries = [
    { name: 'Select', code: '' },
    { name: 'Canada', code: 'CA' },
    { name: 'Mexico', code: 'MX' },
    { name: 'United States', code: 'US' },
]

export default function RegisterForm() {

    const { t } = useTranslation('auth')

    const dispatch = useDispatch()
    const recaptcha = useRef();
    const email = useRef();
    const [errorField, setErrorField] = useState({
        fullName: false,
        email: false,
        userType: false,
        username: false,
        password: false,
        password2: false
    })
    const fullName = useRef(); 
    // const country = useRef();
    // const [countryValue, setCountryValue] = useState(countries[0].name)
    const password2 = useRef();
    const password = useRef();
    const navigate = useNavigate() 
    const { 
        isEmailCodeVerificationSuccess, userType, isRegisterLoading,
        codeVerified, isRegisterSuccess, isRegisterError, registerErrorMessage, 
        verifyRegisterDataSuccess, verifyRegisterDataError, verifyRegisterDataMessage
    } = useSelector( (state) => state.auth )

    const [username, setUsername] = useState("");
    const [acceptedTerms, setAcceptedTerms] = useState(false)

    const handleUsernameChange = (e) => {
        const value = e.target.value;

        // Allow only letters and numbers (no spaces, no special characters)
        const cleaned = value.replace(/[^a-zA-Z0-9]/g, "");

        // Enforce max length of 20
        if (cleaned.length <= 20) {
            setUsername(cleaned);
        }
    };

    const handleRegister = () => { 
        if(!acceptedTerms){
            toast.error(t('errors.termsRequired'))
            return
        }

        if(!recaptcha.current.getValue() ){
            toast.error(t('errors.captchaRequired'))
            return
        }

        let emailValue = email.current.value
        let emailType = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if( userType === 'none' ) {
            setErrorField({ ...errorField, userType: true })
            toast.error(t('errors.accountTypeRequired'))
            return
        }

        if( userType === 'church' && fullName.current.value === '' ) {
            setErrorField({ ...errorField, fullName: true })
            toast.error(t('errors.churchNameRequired'))
            return
        }

        if( emailValue === '' ) {
            setErrorField({ ...errorField, email: true })
            toast.error(t('errors.emailRequired'))
            return
        }

        if( emailType.test(emailValue) === false ) {
            setErrorField({ ...errorField, email: true })
            toast.error(t('errors.emailInvalid'))
            return
        }

        if( userType === 'church' && username === '' ) {
            setErrorField({ ...errorField, username: true })
            toast.error(t('errors.usernameRequired'))
            return
        }

        if( password.current.value === '' ) {
            setErrorField({ ...errorField, password: true })
            toast.error(t('errors.passwordRequired'))
            return
        }

        if( password2.current.value === '' ) {
            setErrorField({ ...errorField, password2: true })
            toast.error(t('errors.confirmPasswordRequired'))
            return
        }

        if( password.current.value !== password2.current.value ) {
            setErrorField({ 
                ...errorField,
                password: true,
                password2: true 
             })
            toast.error(t('errors.passwordMismatch'))
            return
        } 

        dispatch(verifyRegisterData({
            email: email.current.value,
            userType: userType,
            username: userType === 'church' ? username : ''
        })) 

    }

    const sendEmailCode = () => {

        dispatch(setViewEmailConfirmModal({
            email: email.current.value,
        }))
  
        dispatch(sendVerificationEmailCode({
            fullName: fullName.current.value,
            email: email.current.value,
        })) 
    }

    const submitRegister = () => {
        if( userType === 'church') {
            dispatch(registerChurch({
                fullName: fullName.current.value,
                email: email.current.value,
                username: username,
                country: 'null',
                password: password.current.value,
                captchaValue: recaptcha.current.getValue(),
                acceptedTerms: true,
                termsVersion: '2026-09-01',
                platform: 'web'
            }))
        }else{
            dispatch(register({ 
                fullName: fullName.current.value,
                email:  email.current.value,
                password: password.current.value,
                captchaValue: recaptcha.current.getValue(),
                acceptedTerms: true,
                termsVersion: '2026-09-01',
                platform: 'web'
            }))
        }
    } 

    useEffect(() => { 
        if(isEmailCodeVerificationSuccess && codeVerified){
          submitRegister()
        }
    }, [isEmailCodeVerificationSuccess, codeVerified])

    useEffect(() => {
        if( verifyRegisterDataError ) {
            toast.error( verifyRegisterDataMessage )
        } else if( verifyRegisterDataSuccess ) {
            sendEmailCode()
        }
    }, [verifyRegisterDataError, verifyRegisterDataSuccess, verifyRegisterDataMessage])



    useEffect(() => {
        if (isRegisterError) { 
            
            toast.error( registerErrorMessage )

        } else if (isRegisterSuccess) { 
          
            navigate('/login')
            toast.success(t('verification.accountCreated'))
            dispatch(resetAuth())
        } 
    }, [isRegisterSuccess, isRegisterError, registerErrorMessage, navigate, dispatch])

    const handleNavigate = () => {
        navigate('/login')
    }

    return (
        <FormContainer formType={'register'} >
            <LoginHeader
                onClick={() => navigate('/')}
                >
                <img
                    style={{ width: "100px", height: "40px" }} 
                    src={require("../../prayselyLogo.png")} alt="logo" />
            </LoginHeader>
            <FormMain
                formType={'register'}
                >  
                <FormMainHeader>
                    <h1>
                        {
                            userType === 'church' ? (
                                t('signup.churchTitle')
                            )
                            : userType === 'user' &&
                            (
                                t('signup.memberTitle')
                            )

                        }
                    </h1>
                    {
                        userType === 'none' && (
                            <p>{t('signup.chooseAccountType')}</p>
                        )
                    }
                    
                </FormMainHeader>

                <SelectUserType 
                    userTooltip={t('signup.memberTooltip')}
                    churchTooltip={t('signup.churchTooltip')}
                    />
                

                {
                    userType !== 'none' && (

                        <>
 
                            <InputItemWrap>
                                <InputLabel
                                    htmlFor='name'
                                    >
                                    { userType === 'church' ? (
                                        t('signup.churchNameLabel')
                                    )
                                    : userType === 'user' &&
                                    (
                                        t('signup.memberNameLabel')
                                    )}
                                </InputLabel>
                                <InputFieldItem
                                    isError={errorField.fullName}
                                    >
                                    <input
                                        ref={fullName} 
                                        type="text" 
                                        name='name'
                                        placeholder={userType === 'church' ? t('signup.churchNameExample') : t('signup.memberNameExample')}
                                        autoComplete='off'
                                        /> 
                                </InputFieldItem>
                            </InputItemWrap> 
                            <InputItemWrap>
                                <InputLabel
                                    htmlFor='email'
                                    >
                                    {t('signup.emailLabel')}
                                </InputLabel>
                                <InputFieldItem
                                    isError={errorField.email}
                                    >
                                    <input
                                        ref={email} 
                                        type="email" 
                                        name='email'
                                        placeholder={userType === 'church' ? ('grace@mail.com') : ('john@mail.com') }
                                        autoComplete='off'
                                        /> 
                                </InputFieldItem>
                            </InputItemWrap>

                            {
                                userType === 'church' && (
                                    <>
                                        <InputItemWrap>
                                            <InputLabel 
                                                htmlFor='username'>
                                                {t('signup.usernameLabel')}
                                            </InputLabel>
                                            <InputFieldItem
                                                isError={errorField.username}
                                                style={{
                                                    flexDirection: "row",
                                                    position: 'relative',
                                                    alignItems: "center",
                                                    backgroundColor: "white",
                                                    paddingLeft: "5px"
                                                }}
                                                >
                                                <IoAtSharp  
                                                    size={30}
                                                    color="#969696"
                                                    style={{ width: "40px" }}
                                                    />
                                                <input
                                                    onChange={handleUsernameChange}
                                                    style={{ width: "calc(100% -40px)", paddingLeft: 0 }}
                                                    type="text" 
                                                    value={username}
                                                    name='username'
                                                    placeholder={t('signup.usernameExample')}
                                                    autoComplete='off' 
                                                    /> 
                                            </InputFieldItem>
                                        </InputItemWrap>  
                                        {/* <InputItemWrap>
                                            <InputLabel> Country </InputLabel>
                                            <FormControl fullWidth>
                                                <Select 
                                                    id='demo-simple-select'
                                                    style={{ border: 'none', outline: 'none'  }} 
                                                    inputProps={{ 'aria-label': 'Without label' }} 
                                                    sx={{ 
                                                        width: '100%',  
                                                        border: 'none', 
                                                        outline: 'none',
                                                        '& legend': { display: 'none' }, '& fieldset': { top: 0 }
                                                    }}
                                                    displayEmpty 
                                                    value={countryValue}
                                                    renderValue={(selected) => {
                                                        return selected
                                                    }}
                                                    label="Country"
                                                    ref={country}
                                                > 
                                                    {
                                                        countries.map((country, index) => {
                                                            return (
                                                                <MenuItem 
                                                                    key={index} 
                                                                    value={country.name}
                                                                    onClick={() => {
                                                                        setCountryValue(country.name)
                                                                    }}
                                                                    >
                                                                    {country.name}
                                                                </MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </InputItemWrap> */}
                                    </>                       
                                )
                            } 
                            <InputItemWrap>
                                <InputLabel
                                    htmlFor='password'
                                    >
                                    {t('signup.passwordLabel')}
                                </InputLabel>
                                <InputFieldItem
                                    isError={errorField.password || (errorField.password && errorField.password2) }
                                    >
                                    <input
                                        ref={password} 
                                        type="password" 
                                        name='password'
                                        placeholder={t('signup.passwordLabel')}
                                        autoComplete='off'
                                        /> 
                                </InputFieldItem>
                            </InputItemWrap>

                            <InputItemWrap>
                                <InputLabel
                                    htmlFor='confirmPassword'
                                    >
                                    {t('signup.confirmPasswordLabel')}
                                </InputLabel>
                                <InputFieldItem
                                    isError={errorField.password2 || (errorField.password && errorField.password2) }
                                    >
                                    <input
                                        ref={password2} 
                                        type="password" 
                                        name='confirmPassword'
                                        placeholder={t('signup.passwordLabel')}
                                        autoComplete='off'
                                        /> 
                                </InputFieldItem>
                            </InputItemWrap>

                            <ReCAPTCHA 
                                ref={recaptcha}
                                sitekey={"6LfmM8QqAAAAANqh0Ia0RyQIGjJ3hHDK5EB-f6Xr"}
                                />

                            <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '14px', color: '#4d4d4d' }}>
                                <input
                                    type='checkbox'
                                    checked={acceptedTerms}
                                    onChange={(event) => setAcceptedTerms(event.target.checked)}
                                />
                                <span>
                                    {t('signup.termsPrefix')}{' '}
                                    <a href='/terms-of-service' target='_blank' rel='noreferrer'>{t('signup.termsOfService')}</a>
                                    {' '}{t('signup.termsJoiner')}{' '}
                                    <a href='/privacy-policy' target='_blank' rel='noreferrer'>{t('signup.privacyPolicy')}</a>.
                                </span>
                            </label>


                            <AuthButton onClick={handleRegister} >
                                {
                                    isRegisterLoading ? (
                                        <SpinnerSmall />
                                    ) : (
                                        <>
                                         {t('signup.registerAs', { accountType: t(`accountType.${userType === 'user' ? 'member' : 'church'}`) })}
                                        </>
                                    )
                                }
                                   
                            </AuthButton>
                            

                        </>
                    )
                }
                             <DHA>
                                <span>{t('signup.hasAccount')}</span>
                                <p onClick={handleNavigate} >
                                    {t('signup.signIn')}
                                </p>
                            </DHA>

            </FormMain>
            <LoginFooter>
                <span> &copy; 2025 Praysely, Inc </span>
            </LoginFooter>
        </FormContainer>
    )
}
